export default __webpack_public_path__ + "static/media/img-mobile-section-2-token.6b600c83.png";